// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__3Dwic","rootSuccess":"CompleteLink_rootSuccess__fkdQz","rootFailure":"CompleteLink_rootFailure__PBPVp","isDisabled":"CompleteLink_isDisabled__2ejBt"};